import assetPath from '/app/packages/lebenslauf/articles/src/assets/westend61.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')